/**
 * Fallback visualisation palette for tree levels that carry no semantic
 * colour of their own (topic buckets / encapsulations / observations).
 * Segments take a swatch by their position among their siblings, cycling
 * once a ring has more than twelve. Ring 1–2 (signal categories + signals)
 * never reach here — the data adapter stamps them with the LensesV2
 * category colours.
 */
export const VIZ_PALETTE = [
  "#7856FF",
  "#FF7557",
  "#5DC2B9",
  "#F8BC3B",
  "#B2596E",
  "#95D3FF",
  "#FFB27A",
  "#0D7EA0",
  "#3BA974",
  "#FEBBB2",
  "#CA80DC",
  "#5BB7AF",
];

export function swatch(index) {
  return VIZ_PALETTE[index % VIZ_PALETTE.length];
}
